import React from "react";
import TaxList from "./partials/TaxList";
import AddTax from "./partials/AddTax";

export default function Tax() {
    return (
        <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center my-4">
                <h2 className="brand-header">Tax Management</h2>
                <AddTax type="add" />
            </div>
            <TaxList />
        </div>
    );
}
